import React, { Component } from 'react';
import PropTypes from 'prop-types';

var getIsMobile = function getIsMobile() {
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".logo_logo__3xhUB {\n  font-family: Helvetica;\n  padding: 10px; }\n";
var styles = { "logo": "logo_logo__3xhUB" };
styleInject(css);

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M69.347.565a3.053 3.053 0 00-1.61-.534 2.903 2.903 0 00-1.608.4c-.48.355-.837.8-1.073 1.336a2.713 2.713 0 000 1.602l2.95 10.548c-9.1 13.322-17.145 25.116-24.136 35.384L28.182 13.917l7.107-9.613c.367-.5.545-1.078.536-1.736-.017-.557-.24-1.091-.67-1.602C34.81.534 34.32.222 33.678.03c-.553-.085-1.134.004-1.743.267L1.498 14.051a3.206 3.206 0 00-1.206 1.068c-.25.546-.34 1.08-.269 1.602.078.634.301 1.168.67 1.603.454.41.946.632 1.476.667l10.86 1.87c8.598 15.116 16.241 28.424 22.93 39.923A41324.767 41324.767 0 0014.773 91.76a1582.074 1582.074 0 01-5.498 8.012c-.625.961-1.117 1.673-1.475 2.136a6.145 6.145 0 01-.268.534c-.06.089-.105.134-.134.134-1.634 2.843-.874 4.223 2.28 4.139a2.304 2.304 0 001.072-.267c.41-.157.723-.38.939-.668l29.902-35.116c7.982 13.964 14.06 24.557 18.236 31.778 2.255 3.896 3.954 6.789 5.095 8.679a61.518 61.518 0 011.207 2.27c.217.269.352.447.402.534.084.165.129.254.134.267 1.665 2.267 3.05 2.401 4.157.401.39-.393.613-.883.67-1.469.163-.485.118-.974-.134-1.469L49.234 61.585l31.645-37.253 11.933 2.137c.63.15 1.211.06 1.744-.268.545-.222.947-.622 1.206-1.201.263-.514.308-1.093.135-1.736-.08-.547-.349-1.036-.805-1.469L69.347.565z",
  fill: "#AE4860"
});

var cross_country = "data:image/svg+xml,%3Csvg%20width%3D%2296%22%20height%3D%22116%22%20viewBox%3D%220%200%2096%20116%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M69.347%200.565143C68.8735%200.239334%2068.3372%200.0613036%2067.7379%200.0310523C67.1572%200.00949397%2066.6209%200.143017%2066.1289%200.431621C65.6498%200.785943%2065.2922%201.23102%2065.0562%201.76685C64.8949%202.31624%2064.8949%202.85033%2065.0562%203.36912L68.0061%2013.9174C58.9063%2027.2387%2050.861%2039.0333%2043.8702%2049.3009L28.1819%2013.9174L35.2886%204.30378C35.6556%203.80411%2035.8344%203.22551%2035.8249%202.56798C35.8082%202.01094%2035.5847%201.47685%2035.1545%200.965712C34.8112%200.533502%2034.3196%200.221948%2033.6795%200.0310523C33.1257%20-0.0537903%2032.5446%200.0352253%2031.9364%200.298098L1.4983%2014.0509C1.01712%2014.2936%200.614857%2014.6497%200.291509%2015.1191C0.0421883%2015.6647%20-0.0472037%2016.1988%200.0233324%2016.7214C0.100852%2017.3549%200.324333%2017.889%200.693774%2018.3237C1.14737%2018.7336%201.63903%2018.9562%202.16875%2018.9913L13.0299%2020.8606C21.6269%2035.9768%2029.27%2049.2846%2035.959%2060.7839C26.5878%2074.4762%2019.5259%2084.802%2014.773%2091.7612C12.3197%2095.3534%2010.4871%2098.0239%209.27543%2099.7726C8.64968%20100.734%208.15803%20101.446%207.80046%20101.909C7.69151%20102.147%207.60212%20102.325%207.53228%20102.443C7.47187%20102.532%207.42717%20102.577%207.39819%20102.577C5.76399%20105.42%206.52382%20106.8%209.67769%20106.716C10.073%20106.71%2010.4305%20106.621%2010.7504%20106.449C11.1596%20106.292%2011.4725%20106.069%2011.689%20105.781L41.5907%2070.6646C49.5732%2084.6295%2055.6518%2095.2223%2059.8267%20102.443C62.0821%20106.339%2063.7806%20109.232%2064.9221%20111.122C65.4878%20112.149%2065.89%20112.906%2066.1289%20113.392C66.3464%20113.661%2066.4805%20113.839%2066.5312%20113.926C66.6153%20114.091%2066.66%20114.18%2066.6652%20114.193C68.3302%20116.46%2069.7157%20116.594%2070.822%20114.594C71.2113%20114.201%2071.4348%20113.711%2071.4924%20113.125C71.6551%20112.64%2071.6104%20112.151%2071.3583%20111.656L49.2338%2061.585L80.8786%2024.3322L92.8125%2026.4686C93.4421%2026.6188%2094.0231%2026.5298%2094.5556%2026.2015C95.1007%2025.9793%2095.503%2025.5788%2095.7624%2024.9998C96.0253%2024.4859%2096.0701%2023.9073%2095.8965%2023.264C95.8165%2022.7174%2095.5484%2022.2278%2095.092%2021.7953L69.347%200.565143Z%22%20fill%3D%22%23AE4860%22%2F%3E%3C%2Fsvg%3E";

var CrossCountryLogo = function CrossCountryLogo(_ref) {
  var width = _ref.width;
  return React.createElement('img', { src: cross_country, width: width || 100, className: styles.logo, alt: "cross country logo" });
};

var Logo = function Logo(_ref) {
  var url = _ref.url,
      a11y = _ref.a11y;
  return React.createElement('img', { src: url, width: 200, className: styles.logo, alt: a11y });
};

function toVal(mix) {
	var k, y, str='';
	if (mix) {
		if (typeof mix === 'object') {
			if (Array.isArray(mix)) {
				for (k=0; k < mix.length; k++) {
					if (mix[k] && (y = toVal(mix[k]))) {
						str && (str += ' ');
						str += y;
					}
				}
			} else {
				for (k in mix) {
					if (mix[k] && (y = toVal(k))) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else if (typeof mix !== 'boolean' && !mix.call) {
			str && (str += ' ');
			str += mix;
		}
	}
	return str;
}

function clsx () {
	var i=0, x, str='';
	while (i < arguments.length) {
		if (x = toVal(arguments[i++])) {
			str && (str += ' ');
			str += x;
		}
	}
	return str;
}

var css$1 = "html, body {\n  margin: 0px;\n  padding: 0px;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh; }\n\n#grid_root__3ldKg {\n  margin: 0px;\n  padding: 0px;\n  position: absolute !important;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh; }\n\nul {\n  list-style-type: none;\n  margin: 0px;\n  pointer-events: none; }\n\nli {\n  pointer-events: none; }\n\n.grid_grid__2FDMF {\n  display: grid; }\n  @media (min-width: 576px) {\n    .grid_grid__2FDMF {\n      padding: 0 20px; } }\n  @media (min-width: 992px) {\n    .grid_grid__2FDMF {\n      margin-left: auto;\n      margin-right: auto; } }\n  @media (min-width: 1400px) {\n    .grid_grid__2FDMF {\n      margin-bottom: 20px;\n      margin-top: 20px; } }\n";
var styles$1 = { "root": "grid_root__3ldKg", "grid": "grid_grid__2FDMF" };
styleInject(css$1);

/**
 * Component for displaying elements in grid.
 * 
 * @component
 * @example
 * const children = [<Column><Row /></Column>]
 * const customStyle = {width: 200}
 * return (
 *   <Grid customStyle={customStyle}>
 *      {children}
 *   </Grid>
 * )
 */
var Grid = function Grid(_ref) {
  var children = _ref.children,
      customStyle = _ref.customStyle;

  return React.createElement(
    "div",
    { className: styles$1.grid, style: customStyle },
    children
  );
};

Grid.propTypes = {
  /**
   * Grid's children 
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  /**
   * Grid's custom style
   */
  customStyle: PropTypes.shape({})
};

Grid.defaultProps = {
  children: null,
  customStyle: {}
};

var css$2 = "html, body {\n  margin: 0px;\n  padding: 0px;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh; }\n\n#column_root__3SUAA {\n  margin: 0px;\n  padding: 0px;\n  position: absolute !important;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh; }\n\nul {\n  list-style-type: none;\n  margin: 0px;\n  pointer-events: none; }\n\nli {\n  pointer-events: none; }\n\n.column_column__jCbyk {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  margin: 0px;\n  padding: 0px;\n  pointer-events: none; }\n  .column_column__transparent__11gCj {\n    background: transparent; }\n  .column_column__opaque__DcCN7 {\n    background: #eee; }\n  @media (min-width: 576px) {\n    .column_column__jCbyk {\n      padding: 0px; } }\n  @media (min-width: 992px) {\n    .column_column__jCbyk {\n      margin-left: auto;\n      margin-right: auto; } }\n  @media (min-width: 1400px) {\n    .column_column__jCbyk {\n      margin-bottom: 20px;\n      margin-top: 20px; } }\n";
var styles$2 = { "root": "column_root__3SUAA", "column": "column_column__jCbyk", "column__transparent": "column_column__transparent__11gCj", "column__opaque": "column_column__opaque__DcCN7" };
styleInject(css$2);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// <ExampleComponent className={clsx(styles.examplecomponentstyle, "pa5 bg-yellow")}/>

var Column = function Column(_ref) {
  var _clsx;

  var children = _ref.children,
      _ref$hasBackground = _ref.hasBackground,
      hasBackground = _ref$hasBackground === undefined ? true : _ref$hasBackground,
      _ref$hasChildrenCente = _ref.hasChildrenCentered,
      hasChildrenCentered = _ref$hasChildrenCente === undefined ? true : _ref$hasChildrenCente,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? "#eee" : _ref$backgroundColor,
      _ref$customStyle = _ref.customStyle,
      customStyle = _ref$customStyle === undefined ? {} : _ref$customStyle;

  var style = hasBackground ? _extends$1({ backgroundColor: backgroundColor, alignItems: hasChildrenCentered }, customStyle) : customStyle;
  style["alignItems"] = hasChildrenCentered ? "center" : "flex-start";

  return React.createElement(
    "div",
    {
      className: clsx((_clsx = {}, defineProperty(_clsx, styles$2.column, true), defineProperty(_clsx, styles$2.column__opaque, hasBackground), defineProperty(_clsx, styles$2.column__transparent, hasBackground), _clsx)),
      style: style
    },
    children
  );
};

var css$3 = "@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&family=Noto+Sans+JP:wght@300&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap\");\n.checkbox_checkbox__3UD2E {\n  display: flex;\n  position: relative;\n  pointer-events: none; }\n\n.checkbox_checkboxForm__3E4kX {\n  display: inline-block;\n  position: absolute;\n  top: -5px;\n  left: -30px;\n  pointer-events: none; }\n\n.checkbox_checkboxForm__3E4kX::after {\n  content: \"\";\n  display: inline-block;\n  opacity: 1;\n  height: 24px;\n  width: 24px;\n  border: none;\n  background: white;\n  border-radius: 2px; }\n\n.checkbox_checkboxForm__3E4kX::before {\n  content: none;\n  display: inline-block;\n  position: absolute;\n  top: 8px;\n  left: 7px;\n  height: 5px;\n  width: 9px;\n  border-left: 2px solid;\n  border-bottom: 2px solid;\n  transform: rotate(-45deg); }\n\n.checkbox_checkboxForm__3E4kX::before {\n  content: \"\"; }\n\n.checkbox_checkboxFunction__2qQWI {\n  opacity: 1;\n  pointer-events: all; }\n";
var styles$3 = { "checkbox": "checkbox_checkbox__3UD2E", "checkboxForm": "checkbox_checkboxForm__3E4kX", "checkboxFunction": "checkbox_checkboxFunction__2qQWI" };
styleInject(css$3);

var Checkbox = function Checkbox(_ref) {
  var _React$createElement;

  var isChecked = _ref.isChecked,
      id = _ref.id,
      handleChange = _ref.handleChange;

  var classNameSelected = isChecked ? "checkboxFormSelected::before" : "";
  var className = styles$3.checkboxFunction + " " + styles$3[classNameSelected];
  return React.createElement("div", (_React$createElement = {
    className: styles$3.checkbox,
    role: "checkbox",
    id: id
  }, defineProperty(_React$createElement, "className", className), defineProperty(_React$createElement, "checked", isChecked), defineProperty(_React$createElement, "onChange", handleChange), _React$createElement));
};

var css$4 = "@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&family=Noto+Sans+JP:wght@300&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap\");\n.radio_radio__Uff3n {\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  border-radius: 100%;\n  background-color: white;\n  border: 2px solid #2b2b2b;\n  cursor: pointer;\n  pointer-events: all;\n  margin: 2px 0; }\n\n.radio_radioSelected__2kq8f {\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  border-radius: 100%;\n  background-color: white;\n  border: 2px solid #2b2b2b;\n  cursor: pointer;\n  margin: 2px 0; }\n\n.radio_radio__Uff3n::after {\n  content: none; }\n\n.radio_radioSelected__2kq8f::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  background: #2b2b2b;\n  width: 10px;\n  height: 10px;\n  border-radius: 100%; }\n\n.radio_radioGesture__2Nb15 {\n  display: inline-block;\n  position: relative;\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  background-color: white;\n  border: 2px solid blue;\n  cursor: pointer;\n  pointer-events: all;\n  margin: 2px 0; }\n\n.radio_radioGestureSelected__3Hh_E {\n  display: inline-block;\n  position: relative;\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  background-color: white;\n  border: 2px solid blue;\n  cursor: pointer;\n  margin: 2px 0; }\n\n.radio_radioGesture__2Nb15::after {\n  content: none; }\n\n.radio_radioGestureSelected__3Hh_E::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 13px;\n  left: 13px;\n  background: blue;\n  width: 25px;\n  height: 25px;\n  border-radius: 100%; }\n";
var styles$4 = { "radio": "radio_radio__Uff3n", "radioSelected": "radio_radioSelected__2kq8f", "radioGesture": "radio_radioGesture__2Nb15", "radioGestureSelected": "radio_radioGestureSelected__3Hh_E" };
styleInject(css$4);

// utils

var isMobile = getIsMobile();

var device = isMobile ? 'mobile' : 'desktop';
var DeviceContext = React.createContext({ detectedDevice: device });

var useDeviceDetection = function useDeviceDetection() {
	// not sure why useContext isn't working here?!?!
	//const state = useContext(DeviceContext);
	var state = DeviceContext._currentValue;
	return state;
};

var Radio = function Radio(_ref) {
  var isSelected = _ref.isSelected,
      id = _ref.id,
      handleChange = _ref.handleChange,
      tabIndex = _ref.tabIndex;

  var mobileState = useDeviceDetection();

  var key = "radio";

  var className = isSelected ? styles$4[key + "Selected"] : styles$4["" + key];

  return React.createElement("div", {
    className: className,
    role: "radio",
    id: id,
    "data-value": id,
    type: "radio",
    checked: isSelected,
    onClick: handleChange,
    onKeyDown: handleChange,
    tabIndex: tabIndex
  });
};

// https://www.w3.org/TR/2016/WD-wai-aria-practices-1.1-20160317/examples/radio/radio.html

var RadioGroup = function RadioGroup(_ref) {
  var handleChange = _ref.handleChange,
      list = _ref.list,
      selectedId = _ref.selectedId;

  var getSelected = function getSelected(radio) {
    return radio.id === selectedId;
  };
  var getTabIndex = function getTabIndex(radio) {
    return radio.id === selectedId ? 0 : 1;
  };

  var radiobuttons = list.map(function (radio) {
    return React.createElement(Radio, {
      key: radio.id,
      id: radio.id,
      handleChange: handleChange,
      isSelected: getSelected(radio),
      tabIndex: getTabIndex(radio)
    });
  });

  return React.createElement(
    Column,
    { role: "radiogroup" },
    radiobuttons
  );
};

var css$5 = "@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&family=Noto+Sans+JP:wght@300&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap\");\n.button_button__2LeFx {\n  border: none;\n  border-radius: 4px;\n  padding: 10px 14px;\n  width: 100px;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"Noto Sans JP\", Helvetica, Arial, sans-serif;\n  margin: 4px; }\n";
var styles$5 = { "button": "button_button__2LeFx" };
styleInject(css$5);

/*
Atom

renders 1 native element
*/

var Button = function Button(_ref) {
  var text = _ref.text,
      label = _ref.label,
      handleClick = _ref.handleClick,
      customStyle = _ref.customStyle;
  return React.createElement(
    "button",
    {
      style: customStyle,
      onClick: function onClick() {
        return handleClick(label);
      },
      className: styles$5.button
    },
    text
  );
};

var css$6 = "html, body {\n  margin: 0px;\n  padding: 0px;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh; }\n\n#row_root__2ZnRQ {\n  margin: 0px;\n  padding: 0px;\n  position: absolute !important;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh; }\n\nul {\n  list-style-type: none;\n  margin: 0px;\n  pointer-events: none; }\n\nli {\n  pointer-events: none; }\n\n.row_row__1jDNc {\n  display: flex;\n  position: relative;\n  margin: 0px;\n  padding: 0px;\n  flex-wrap: wrap;\n  pointer-events: none; }\n  @media (min-width: 576px) {\n    .row_row__1jDNc {\n      padding: 0 20px; } }\n  @media (min-width: 992px) {\n    .row_row__1jDNc {\n      margin-left: auto;\n      margin-right: auto; } }\n  @media (min-width: 1400px) {\n    .row_row__1jDNc {\n      margin-bottom: 20px;\n      margin-top: 20px; } }\n";
var styles$6 = { "root": "row_root__2ZnRQ", "row": "row_row__1jDNc" };
styleInject(css$6);

/*
Atom

renders 1 native element
*/

var Row = function Row(_ref) {
  var children = _ref.children,
      _ref$hasChildrenCente = _ref.hasChildrenCentered,
      hasChildrenCentered = _ref$hasChildrenCente === undefined ? true : _ref$hasChildrenCente;

  var style = {};
  style["justifyContent"] = hasChildrenCentered ? "center" : "flex-start";

  return React.createElement(
    'div',
    { className: styles$6.row, style: style },
    children
  );
};

var css$7 = ".image_image__38bWr {\n  font-family: Helvetica;\n  padding: 10px; }\n";
var styles$7 = { "image": "image_image__38bWr" };
styleInject(css$7);

var Image = function Image(_ref) {
  var url = _ref.url,
      width = _ref.width,
      a11y = _ref.a11y;
  return React.createElement('img', { src: url, width: width, className: styles$7.image, alt: a11y });
};

var css$8 = "@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&family=Noto+Sans+JP:wght@300&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap\");\n.headline_headline__eVw5O {\n  font-family: \"Bree Serif\", Helvetica, Arial;\n  font-size: 30px;\n  font-weight: 500;\n  color: #2b2b2b;\n  margin: 0px; }\n";
var styles$8 = { "headline": "headline_headline__eVw5O" };
styleInject(css$8);

var Headline = function Headline(_ref) {
  var text = _ref.text;
  return React.createElement(
    'h1',
    { className: styles$8.headline },
    text
  );
};

var css$9 = "@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&family=Noto+Sans+JP:wght@300&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap\");\n.subheadline_subheadline__arYdR {\n  font-family: \"Bree Serif\", Helvetica, Arial;\n  font-size: 22px;\n  font-weight: 500;\n  color: #2b2b2b;\n  margin: 0px; }\n  .subheadline_subheadline__large__1pasq {\n    font-size: 24px; }\n  .subheadline_subheadline__medium__3LZBn {\n    font-size: 20px; }\n  .subheadline_subheadline__small__3ZmsQ {\n    font-size: 16px; }\n";
var styles$9 = { "subheadline": "subheadline_subheadline__arYdR", "subheadline__large": "subheadline_subheadline__large__1pasq", "subheadline__medium": "subheadline_subheadline__medium__3LZBn", "subheadline__small": "subheadline_subheadline__small__3ZmsQ" };
styleInject(css$9);

var SubHeadline = function SubHeadline(_ref) {
  var text = _ref.text,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? "large" : _ref$size;

  var key = 'subheadline__' + size;
  var className = styles$9.subheadline + ' ' + styles$9[key];
  return React.createElement(
    'h2',
    { className: className },
    text
  );
};

var css$a = "@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&family=Noto+Sans+JP:wght@300&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap\");\n.paragraph_paragraph__3ZwjF {\n  font-family: \"Noto Sans JP\", Helvetica, Arial, sans-serif;\n  font-size: 16px;\n  width: 300px;\n  text-align: left; }\n\n@media only all and (min-width: 800px) {\n  p {\n    width: 600px; } }\n";
var styles$a = { "paragraph": "paragraph_paragraph__3ZwjF" };
styleInject(css$a);

var Paragraph = function Paragraph(_ref) {
  var text = _ref.text,
      _ref$customStyle = _ref.customStyle,
      customStyle = _ref$customStyle === undefined ? {} : _ref$customStyle;
  return React.createElement(
    'p',
    { className: styles$a.paragraph, style: customStyle },
    text
  );
};

var css$b = "@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&family=Noto+Sans+JP:wght@300&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap\");\n.link_link__2o6wU {\n  font-family: \"Bree Serif\", Helvetica, Arial;\n  font-size: 22px;\n  font-weight: 500;\n  color: #308e8a;\n  margin: 0px;\n  pointer-events: all;\n  word-wrap: break-word; }\n  .link_link__large__X6Sz7 {\n    font-size: 24px; }\n  .link_link__medium__2i4kX {\n    font-size: 20px; }\n  .link_link__small__3bruO {\n    font-size: 16px; }\n";
var styles$b = { "link": "link_link__2o6wU", "link__large": "link_link__large__X6Sz7", "link__medium": "link_link__medium__2i4kX", "link__small": "link_link__small__3bruO" };
styleInject(css$b);

var Link = function Link(_ref) {
  var url = _ref.url,
      text = _ref.text,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? "small" : _ref$size;
  return React.createElement(
    'a',
    {
      href: url,
      target: '_blank',
      rel: 'noopener, noreferrer',
      className: styles$b.link + ' ' + styles$b['link__' + size]
    },
    text
  );
};

var css$c = "@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&family=Noto+Sans+JP:wght@300&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap\");\n.label_label__GUbjF {\n  border: none; }\n";
var styles$c = { "label": "label_label__GUbjF" };
styleInject(css$c);

var Label = function Label(_ref) {
  var text = _ref.text,
      forId = _ref.forId;
  return React.createElement(
    "label",
    { className: styles$c.label, htmlFor: forId },
    text
  );
};

var CheckboxLabel = function CheckboxLabel(_ref) {
  var _ref$config = _ref.config,
      text = _ref$config.text,
      id = _ref$config.id,
      isChecked = _ref$config.isChecked,
      handleChange = _ref$config.handleChange;

  return React.createElement(
    Row,
    null,
    React.createElement(Checkbox, { text: text, id: id, isChecked: isChecked, handleChange: handleChange }),
    React.createElement(Label, { text: text, forId: id })
  );
};

var Wolf = function Wolf(_ref) {
  var _ref$config = _ref.config,
      url = _ref$config.url,
      text = _ref$config.text,
      a11y = _ref$config.a11y,
      hasBackground = _ref$config.hasBackground;

  return React.createElement(
    Column,
    { hasBackground: hasBackground },
    React.createElement(SubHeadline, { text: text }),
    React.createElement(Image, { url: url, width: '300', a11y: a11y })
  );
};

var css$d = "html, body {\n  margin: 0px;\n  padding: 0px;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh; }\n\n#styles_root__36Ay5 {\n  margin: 0px;\n  padding: 0px;\n  position: absolute !important;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh; }\n\nul {\n  list-style-type: none;\n  margin: 0px;\n  pointer-events: none; }\n\nli {\n  pointer-events: none; }\n";
styleInject(css$d);

// atoms

var defaultTheme = {
	primaryColor: 'blue',
	secondaryColor: 'pink'
};

var ThemeContext = React.createContext(defaultTheme);

var nationalparks = [{ id: 0, name: "Alqonquin" }, { id: 1, name: "Jasper" }, { id: 2, name: "Elk Island" }, { id: 3, name: "Rouge" }];

var DeviceContext$1 = React.createContext("device");

var Documentation = function (_Component) {
  inherits(Documentation, _Component);

  function Documentation(props) {
    classCallCheck(this, Documentation);

    var _this = possibleConstructorReturn(this, (Documentation.__proto__ || Object.getPrototypeOf(Documentation)).call(this, props));

    _this.state = {
      buttonFeedback: "",
      logoComp: {
        isChecked: false
      },
      radios: {
        selectedId: 0
      }
    };

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleRadioChange = _this.handleRadioChange.bind(_this);
    return _this;
  }

  createClass(Documentation, [{
    key: "handleClick",
    value: function handleClick(label) {
      var buttonFeedback = label + " has been clicked!";
      this.setState({ buttonFeedback: buttonFeedback });
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({ logoComp: { isChecked: !this.state.logoComp.isChecked } });
    }
  }, {
    key: "handleRadioChange",
    value: function handleRadioChange(e) {
      this.setState({
        radios: { selectedId: Number(event.target.dataset.value) }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _state = this.state,
          buttonFeedback = _state.buttonFeedback,
          logoComp = _state.logoComp,
          selectedId = _state.radios.selectedId;


      var isMobile = getIsMobile();
      var contextValue = isMobile ? "mobile" : "desktop";

      var device = isMobile ? "Mobile" : "Desktop";
      var hello = "This system will detect the device: " + device + " and will respond accordingly providing pleasant UX for writing and reading technical articles as well as experimenting with javascript and svg.";

      return React.createElement(
        DeviceContext$1.Provider,
        { value: contextValue },
        React.createElement(
          Grid,
          null,
          React.createElement(
            Column,
            { hasBackground: false },
            React.createElement(Headline, { text: "Cross-Country" }),
            React.createElement(SubHeadline, { text: "Design System" }),
            React.createElement(Paragraph, {
              text: hello,
              customStyle: { padding: 20, textAlign: "center" }
            }),
            React.createElement(SubHeadline, { text: "Atoms" }),
            React.createElement(
              Row,
              null,
              React.createElement(
                Column,
                null,
                React.createElement(
                  "ul",
                  null,
                  React.createElement(
                    "li",
                    null,
                    React.createElement(CheckboxLabel, {
                      config: {
                        text: "Logo",
                        id: "logo",
                        isChecked: logoComp.isChecked,
                        handleChange: this.handleChange
                      }
                    })
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(CheckboxLabel, { config: { text: "Button", id: "button" } })
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(CheckboxLabel, {
                      config: { text: "Headline", id: "headline" }
                    })
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(CheckboxLabel, {
                      config: { text: "SubHeadline", id: "subheadline" }
                    })
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(CheckboxLabel, { config: { text: "Image", id: "image" } })
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(CheckboxLabel, { config: { text: "Column", id: "column" } })
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(CheckboxLabel, { config: { text: "Row", id: "row" } })
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(CheckboxLabel, { config: { text: "Line", id: "line" } })
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(CheckboxLabel, { config: { text: "List", id: "list" } })
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(CheckboxLabel, { config: { text: "Item", id: "item" } })
                  )
                )
              ),
              React.createElement(
                Column,
                { hasChildrenCentered: false },
                React.createElement(SubHeadline, { text: "Link" }),
                React.createElement(Paragraph, { text: "a hyper link that wraps the anchor element" }),
                React.createElement(Link, {
                  text: "Editorial Design Patterns With CSS Grid And Named Columns",
                  url: "https://www.smashingmagazine.com/2019/10/editorial-design-patterns-css-grid-subgrid-naming/"
                })
              ),
              React.createElement(
                Column,
                null,
                React.createElement(SubHeadline, { text: "Radio Button" }),
                React.createElement(Paragraph, { text: "a radio button for cross country" }),
                React.createElement(RadioGroup, {
                  list: nationalparks,
                  handleChange: this.handleRadioChange,
                  selectedId: selectedId
                })
              ),
              React.createElement(
                Column,
                null,
                React.createElement(SubHeadline, { text: "Logo" }),
                React.createElement(Paragraph, { text: "a simple logo for cross country" }),
                React.createElement(
                  Row,
                  null,
                  React.createElement(Logo, { url: cross_country, a11y: "cross country logo" })
                )
              ),
              React.createElement(
                Column,
                null,
                React.createElement(SubHeadline, { text: "Button" }),
                React.createElement(Paragraph, { text: "a simple button that be can used for interaction" }),
                React.createElement(
                  Row,
                  null,
                  React.createElement(Button, {
                    handleClick: this.handleClick,
                    text: "click me",
                    label: "green",
                    customStyle: { backgroundColor: "green", color: "white" }
                  }),
                  React.createElement(Button, {
                    text: "click me",
                    label: "grey",
                    handleClick: this.handleClick,
                    customStyle: { backgroundColor: "blue", color: "white" }
                  })
                ),
                React.createElement(Paragraph, { text: buttonFeedback })
              )
            ),
            React.createElement(SubHeadline, { text: "Molecules" }),
            React.createElement(
              Row,
              null,
              React.createElement(
                Column,
                null,
                React.createElement(SubHeadline, { text: "Text with Image" }),
                React.createElement(
                  Row,
                  null,
                  React.createElement(Wolf, {
                    config: {
                      url: "https://i.pinimg.com/originals/c2/99/c8/c299c825b1d9adf653a03760880c2d81.jpg",
                      a11y: "wolf",
                      text: "Wolf"
                    }
                  }),
                  React.createElement(Wolf, {
                    config: {
                      url: "https://i.pinimg.com/originals/3d/26/3e/3d263efde96d082aa041c923a0fe8b08.png",
                      a11y: "princess",
                      text: "princess"
                    }
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Documentation;
}(Component);

var data = {
  headline: "My world needs another design system",
  image: {
    url: "https://images.unsplash.com/photo-1512411233342-92208dfe81af?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80",
    a11y: "a nice aframe from unsplash",
    width: 300
  },
  wolf: {
    url: "https://forallnerds.com/wp-content/uploads/2016/12/Rogue-One-A-Star-Wars-Story-Trailer-1-700x391.jpg",
    text: "K-2SO & Jyn Erso",
    a11y: "K-2SO & Jyn Erso"
  }
};

var headline = data.headline,
    wolf = data.wolf,
    image = data.image;

var config = wolf;

var ReadMe = function ReadMe() {
  return React.createElement(
    Column,
    null,
    React.createElement(Headline, { text: headline }),
    React.createElement(
      Row,
      null,
      React.createElement(Image, image),
      React.createElement(
        Column,
        null,
        React.createElement(Wolf, { config: config })
      )
    )
  );
};

var CrossCountry = function (_Component) {
  inherits(CrossCountry, _Component);

  function CrossCountry() {
    classCallCheck(this, CrossCountry);
    return possibleConstructorReturn(this, (CrossCountry.__proto__ || Object.getPrototypeOf(CrossCountry)).apply(this, arguments));
  }

  createClass(CrossCountry, [{
    key: "render",
    value: function render() {
      return React.createElement(
        Column,
        { hasBackground: false },
        React.createElement(Documentation, { name: "documentation" }),
        React.createElement(SubHeadline, { text: "Read Me", size: "large" }),
        React.createElement(ReadMe, null)
      );
    }
  }]);
  return CrossCountry;
}(Component);

export default CrossCountry;
export { CrossCountryLogo, Logo, Grid, Column, Checkbox, Radio, RadioGroup, Button, Row, Image, Headline, SubHeadline, Paragraph, Link, CheckboxLabel, Wolf, getIsMobile };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/cross-country/dist/index.es.js
// module id = 257
// module chunks = 0